import request from "library/v1/request";

export function createCharge(params, data) {
  return request({
    url: `billing/charges`,
    method: 'post',
    params,
    data
  })
}

export function getBilling(params) {
  return request({
    url: `billing`,
    method: 'get',
    cancelPrevious: true,
    params
  })
}

export function showCharge(chargeId) {
  return request({
    url: `billing/charges/${chargeId}`,
    method: 'get'
  })
}
